<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['values'],
  computed: {
    chartData () {
      return {
        labels: this.values.categories,
        datasets: [
          {
            data: this.values.data,
            backgroundColor: [
              '#8791E8',
              '#8DB2F2',
              '#8ABDDB',
              '#8DE8F2',
              '#87E8D7',
              '#8DF2CB',
              '#8BDBA6',
              '#8DF292'
            ],
            borderWidth: 0,
            barPercentage: 0.8,
            categoryPercentage: 1,
          },
        ]
      }
    }
  },
  data () {
    return {
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: "#e2e2e2",
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            gridLines: {
              color: "#e2e2e2",
            }
          }]
        }
      },
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
